import { render } from "./areaFilterDropdown.vue?vue&type=template&id=21c1e02d"
import script from "./areaFilterDropdown.vue?vue&type=script&lang=js"
export * from "./areaFilterDropdown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__